import { type UseMutationResult, useMutation } from '@tanstack/react-query';
import api from '@/axios';
import { CREATE_PRODUCTION_DECLARATION_CORRECTION_REQUEST_KEY } from '@/keys';
import type {
  CorrectionRequest,
  CorrectionRequestEntityType,
} from '@/types/core/purchase-order/correction-request';

type CreateProductionDeclarationCorrectionRequestVariables = {
  productionDeclarationId: string;
  materialId: string;
  commodityOriginId: string;
  entityType: CorrectionRequestEntityType;
  comment: string;
};

async function createProductionDeclarationCorrectionRequest({
  productionDeclarationId,
  materialId,
  commodityOriginId,
  entityType,
  comment,
}: CreateProductionDeclarationCorrectionRequestVariables): Promise<CorrectionRequest> {
  const response = await api.post<CorrectionRequest>(
    `/production-declarations/${productionDeclarationId}/materials/${materialId}/commodity-origins/${commodityOriginId}/correction-requests`,
    {
      entityType,
      comment,
    },
  );

  return response.data;
}

export function useCreateProductionDeclarationCorrectionRequest(): UseMutationResult<
  CorrectionRequest,
  Error,
  CreateProductionDeclarationCorrectionRequestVariables
> {
  return useMutation({
    mutationKey: CREATE_PRODUCTION_DECLARATION_CORRECTION_REQUEST_KEY,
    mutationFn: createProductionDeclarationCorrectionRequest,
  });
}
